import styled from 'styled-components'

export const StyledContainer = styled.div`
  font-size: 16px;
  color: #989898;
  margin: 0 10px;
  padding: 20px 0 0;
`
